import AddIcon from "@mui/icons-material/Add";
import { Button, Stack } from "@mui/material";
import { AddFromExistingSegmentButton } from "./add-from-existing-segment-button";
import { SegmentGroup } from "./segment-group";

import type { NoNullFields } from "../../../../server/supabase/base-supabase-service";
import type { ChannelName } from "../../../channels/types";
import type { UsableAccountPersonField } from "../../server/supabase-segment-field-service";
import type { Segment, SegmentMode } from "../../types/segment-schema";
import type { SegmentManagerAction, SegmentReducerState } from "./reducer/actions";
import type { Dispatch, FC } from "react";

interface SegmentManagerProps {
  state: SegmentReducerState<Segment>;
  dispatch: Dispatch<SegmentManagerAction<Segment>>;
  fields: NoNullFields<UsableAccountPersonField>[];
  channels: ChannelName[];
  disabled: boolean;
  mode: SegmentMode;
  showPreview: boolean;
}

export const SegmentManager: FC<SegmentManagerProps> = ({
  state,
  dispatch,
  fields,
  channels,
  disabled,
  mode,
  showPreview,
}) => (
  <Stack direction="column" spacing={2} sx={{ mt: 1 }} data-testid="segment-manager">
    {state.segment.segment_json.segments.map((segment, segmentIndex) => (
      <SegmentGroup
        // oxlint-disable-next-line react/no-array-index-key -- Items have no id; state is addressed by index
        key={segmentIndex}
        segment={segment}
        segmentIndex={segmentIndex}
        dispatch={dispatch}
        segmentFields={fields}
        canDelete={state.segment.segment_json.segments.length > 1}
        errors={state.errors}
        channels={channels ?? []}
        disabled={disabled}
        mode={mode}
        showPreview={showPreview}
      />
    ))}
    {!disabled && (
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          variant="text"
          onClick={() => dispatch({ type: "ADD_GROUP" })}
          data-analytics-id="add-group-button"
          startIcon={<AddIcon />}
          sx={{ maxWidth: "fit-content" }}
          disabled={disabled}
        >
          Add new group
        </Button>
        <AddFromExistingSegmentButton dispatch={dispatch} disabled={disabled} />
      </Stack>
    )}
  </Stack>
);
